module.exports = __webpack_public_path__ + "static/media/85239581_3221354041484975_3395211414590193664_n.5454ff19.jpg";